class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const isNormalCartItem = !this.dataset.removeBundle;
      let cartUpdates = [];
      if (isNormalCartItem) {
        const key = this.closest('.CartItem')?.getAttribute('data-line-item-key');
        cartUpdates = [{key, quantity: 0, type: 'normal'}];
      } else {
        // const bundleKey = this.closest(".CartItem")?.getAttribute("data-bundle-key");
        // cartUpdates = bundleKey?.split('-').pop().split(":").map(item => ({id: item, quantity: 0 }))

        const ELM_bundleContainer = this.closest('.CartItem.bundle');
        const ELM_bundleItems = ELM_bundleContainer.querySelectorAll('.CartItem.bundle-item');
        ELM_bundleItems.forEach((item) => {
          cartUpdates.push({
            key: item.getAttribute('data-line-item-key'),
            quantity: 0,
            type: 'bundle-item',
          });
        });
      }

      this.closest('cart-items').updateQuantity({cartUpdates});
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');
    this.cartDrawer = document.querySelector('cart-drawer');
    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]')).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.gwpCartStyle();

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    const key = event.target.closest('.CartItem')?.getAttribute('data-line-item-key');
    const cartUpdates = [{key, quantity: event.target.value, type: 'normal'}];
    this.updateQuantity({
      cartUpdates,
      name: document.activeElement.getAttribute('name'),
    });
    
  }
  

  getSectionsToRender() {
    return [
      {
        class: '.main-cart-items',
        section: 'main-cart',
        selector: '[data-cart-items]',
        isMultiElements: true,
      },
      {
        class: '.main-cart-footer',
        section: 'main-cart',
        selector: '[data-cart-footer]',
        isMultiElements: true,
      },
      {
        class: '.main-cart__content--recap',
        section: 'main-cart',
        selector: '.main-cart__content--recap',
        isMultiElements: true,
      },
      {
        class: '.main-cart-wrapper',
        section: 'main-cart',
        selector: '.main-cart-wrapper',
        isMultiElements: true,
      },
      // {
      //   class: '.icon-bubble-count',
      //   section: 'cart-icon-bubble',
      //   selector: '.shopify-section',
      //   isMultiElements: true
      // },
      {
        class: '.CartPage__Sidebar',
        section: 'main-cart',
        selector: '.CartPage__Sidebar',
        isMultiElements: true,
      },
      {
        class: '.cart-drawer__footer-content',
        section: 'main-cart',
        selector: '[data-cart-footer]',
        isMultiElements: true,
      },
    ];
  }

  gwpCartStyle() {
    const isActive = window?.gwpPromo?.isActive ?? false;
    const freeProductVariantId = window?.gwpPromo?.freeProductVariantId ?? null;

    if (!isActive) {
      return null;
    }
    const gwpCartItems =
      freeProductVariantId &&
      document.querySelectorAll(`[data-variant-id="${freeProductVariantId}"]`);
    gwpCartItems &&
      gwpCartItems.forEach((e) => {
        e.classList.add('gwp-product');
      });
  }

  updateQuantity({cartUpdates, name}) {
    let updates = {};
    let line;
    const cartItems = [...document.querySelectorAll('.CartItem')].map((item, i) => {
      return {
        key: item.getAttribute('data-line-item-key') ?? '0',
        index: i,
      };
    });

    cartItems.forEach((item) => {
      cartUpdates.forEach((innerItem) => {
        if (item.key === innerItem.key) {
          updates[item.key] = innerItem.quantity;
          if (innerItem.type === 'bundle') {
            line = item.index;
          }
        }
      });
    });

    this.enableLoading(line);
    const body = JSON.stringify({
      updates,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch('/cart/update.js', {...fetchConfig(), ...{body}})
      .then((response) => response.text())
      .then(async (state) => {
        const parsedState = JSON.parse(state);
        const dataCart = parsedState.items.filter((item) => !item.handle.includes('bed-bundle'));
        const count = dataCart.reduce((sum, item) => (sum += item.quantity), 0);
        

        this.classList.toggle('is-empty', count === 0);
        const cartFooter = document.querySelectorAll('.main-cart-footer');

        if (cartFooter) {
          cartFooter.forEach((cf) => {
            cf.classList.toggle('is-empty', count === 0);
          });
        }

        const newCartBubbles = document.querySelectorAll('.cart-count-bubble-value');
        newCartBubbles.forEach((item) => {
          item.innerHTML = count;
          if (count > 0) {
            item.classList.add('show');
          } else {
            item.classList.remove('show');
          }
        });

        

        this.getSectionsToRender().forEach((section) => {
          if (section.isMultiElements) {
            const elements = document.querySelectorAll(section.class);
            if (elements) {
              elements.forEach((elm) => {
                const elementToReplace = elm.querySelector(section.selector) || elm;
                elementToReplace.innerHTML = this.getSectionInnerHTML(
                  parsedState.sections[section.section],
                  section.selector
                );
              });
            }
          } else {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) ||
              document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          }
        });

        // this.updateLiveRegions(line, count);
        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`))
          lineItem.querySelector(`[name="${name}"]`).focus();

        this.disableLoading();
      })
      .then(async (data) => {
        const giftWithPurchase = new GiftWithPurchase();
        await giftWithPurchase.loadGWP();

        if (this.cartDrawer) {
          this.cartDrawer?.loadContent();
        }

         document.body.dispatchEvent(new Event("initTheWishlist"));
      })
      .catch((error) => {
        console.log('error', error);
        // this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        // document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document
        .getElementById(`Line-item-error-${line}`)
        .querySelector('.cart-item__error-text').innerHTML =
        window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`Quantity-${line}`).value
        );
    }

    this.currentItemCount = itemCount;
    if (this.lineItemStatusElement) {
      this.lineItemStatusElement.setAttribute('aria-hidden', true);
    }
    const cartStatus = document.querySelectorAll('.cart-live-region-text');
    if (cartStatus) {
      cartStatus.forEach((ct) => {
        ct.setAttribute('aria-hidden', false);
      });

      setTimeout(() => {
        cartStatus.forEach((ct) => {
          ct.setAttribute('aria-hidden', true);
        });
      }, 1000);
    }
  }

  getSectionInnerHTML(html, selector) {
    const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
    const selectorHtml = parsedHtml.querySelector(selector)?.innerHTML || '';
    return selectorHtml;
  }

  enableLoading(line) {
    document.querySelectorAll('.main-cart-items').forEach((item) => {
      item.classList.add('cart__items--disabled');
    });
    this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach((overlay) =>
      overlay.classList.remove('hidden')
    );
    document.activeElement.blur();
    if (this.lineItemStatusElement) {
      this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }
  }

  disableLoading() {
    document.querySelectorAll('.main-cart-items').forEach((item) => {
      item.classList.remove('cart__items--disabled');
    });
  }
}

customElements.define('cart-items', CartItems);
